<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Usuario de empresa</h3>
            </div>
        </div>
        <div class="layout__main">
            <div class="layout__main-form">
                <div class="card">
                    <div class="card__title">
                        <h5>Información del usuario {{ modelValue.nombre_usuario }}</h5>
                    </div>
                    <div class="card__content">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field readonly v-model="modelValue.nombre" id="nombre">
                                        Nombre
                                    </input-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-field">
                                    <input-field readonly v-model="modelValue.email" id="email">
                                        E-mail
                                    </input-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <tabla-usuario-empresa :empresasUsuario="modelValue.empresas" v-model="roles"></tabla-usuario-empresa>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="layout__main-buttons">
                <div class="card">
                    <div class="card__content">
                        <button @click="guardar" type="button" class="btn-success"><i class="fa fa-save"></i> <span>Guardar</span></button>
                        <button @click="$emit('cancelar')" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Cancelar</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : true
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            roles : [],
            url : url
        }
    },
    methods : {
        guardar : function () {
            if (this.roles.length > 0) {
                let that = this;
                axios.post(this.url + '/usuarios/administrar', {
                    id_usuario : this.modelValue.id,
                    roles : this.roles
                }).then(function (response) {
                    swal('El usuario ha sido actualizado.', 'Realizado', 'success');
                    that.$emit('updated');
                });
            }
            else 
                swal('El usuario debe ser asignado al menos a una empresa.', 'Mensaje', 'warning');
        }
    },
    mounted : function () {
        for (let i = 0; i < this.modelValue.roles.length; i++)
            this.roles.push(this.modelValue.roles[i].id);
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/usuarios/UsuarioEmpresa.vue